import { render, staticRenderFns } from "./ChecklistItemD.vue?vue&type=template&id=7aa28520"
import script from "./ChecklistItemD.vue?vue&type=script&lang=js"
export * from "./ChecklistItemD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports